var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-result',{attrs:{"status":"403","title":"403","sub-title":"非常抱歉，你没有此页面的访问权限，因为你的账号不是一个Customer账号"}})
}
var staticRenderFns = []

export { render, staticRenderFns }